import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import ProtectedRoute from './components/auth/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';

// Lazy load pages
const Jobs = lazy(() => import('./pages/Jobs'));
const JobDetail = lazy(() => import('./pages/JobDetail'));
const Events = lazy(() => import('./pages/Events'));
const EventDetail = lazy(() => import('./pages/EventDetail'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const Companies = lazy(() => import('./pages/Companies'));
const CompanyDetail = lazy(() => import('./pages/CompanyDetail'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/admin/Dashboard'));
const AdminCompanies = lazy(() => import('./pages/admin/Companies'));
const AdminJobs = lazy(() => import('./pages/admin/Jobs'));
const AdminEvents = lazy(() => import('./pages/admin/Events'));
const EventForm = lazy(() => import('./pages/admin/EventForm'));
const AdminBlogs = lazy(() => import('./pages/admin/Blogs'));
const BlogForm = lazy(() => import('./pages/admin/BlogForm'));
const AdminLayout = lazy(() => import('./pages/admin/AdminLayout'));
const CompanyForm = lazy(() => import('./pages/admin/CompanyForm'));
const JobForm = lazy(() => import('./pages/admin/JobForm'));
const LoginForm = lazy(() => import('./components/auth/LoginForm'));

// Loading component
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
  </div>
);

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-grow">
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/jobs/:id" element={<JobDetail />} />
                <Route path="/events" element={<Events />} />
                <Route path="/events/:id" element={<EventDetail />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/companies" element={<Companies />} />
                <Route path="/companies/:slug" element={<CompanyDetail />} />
                
                {/* Auth Routes */}
                <Route path="/login" element={<LoginForm />} />
                <Route path="/register" element={<LoginForm />} />

                {/* Admin Routes */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="companies" element={<AdminCompanies />} />
                  <Route path="companies/new" element={<CompanyForm />} />
                  <Route path="companies/edit/:id" element={<CompanyForm />} />
                  <Route path="jobs" element={<AdminJobs />} />
                  <Route path="jobs/new" element={<JobForm />} />
                  <Route path="jobs/edit/:id" element={<JobForm />} />
                  <Route path="events" element={<AdminEvents />} />
                  <Route path="events/new" element={<EventForm />} />
                  <Route path="events/edit/:id" element={<EventForm />} />
                  <Route path="blogs" element={<AdminBlogs />} />
                  <Route path="blogs/new" element={<BlogForm />} />
                  <Route path="blogs/edit/:id" element={<BlogForm />} />
                </Route>
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App; 